import { SnackbarProvider } from 'notistack'
import ReactDOM from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import store from './store/store'
import { consumeSsoSession } from './utils/ssoSession.util'

// Debe correr antes del render: los guards de ruta evalúan store.user en el primer render.
consumeSsoSession()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ReduxProvider store={store}>
    <BrowserRouter>
      <SnackbarProvider maxSnack={5} autoHideDuration={4000}>
        <App />
      </SnackbarProvider>
    </BrowserRouter>
  </ReduxProvider>
)
